export default `<div class="styles__CategoryList">
<div class="column">
   <div class="group">
      <a role="link" href="/view/men/jackets/" title="Men's Jackets">
         <h2 class="title">Men</h2>
      </a>
      <ul>
         <li><a href="/view/men/jackets/" title="Men's Jackets"><div class="item"><div class="item-label">Jackets</div></div></a></li>
         <li><a href="/view/men/jackets/parkas/" title="Men's Parkas"><div class="item"><div class="item-label">Parkas</div></div></a></li>
         <li><a href="/view/men/vests/" title="Men's Vests"><div class="item"><div class="item-label">Vests</div></div></a></li>
         <li><a href="/view/men/jackets/material-fleece/" title="Men's Performance Fleece"><div class="item"><div class="item-label">Performance Fleece</div></div></a></li>
         <li><a href="/view/men/pants/type-ski/" title="Men's Ski Pants"><div class="item"><div class="item-label">Ski Pants</div></div></a></li>
      </ul>
   </div>
   <div class="group">
      <a role="link" href="/view/women/jackets/" title="Women's Jackets">
         <h2 class="title">Women</h2>
      </a>
      <ul>
         <li><a href="/view/women/jackets/" title="Women's Jackets"><div class="item"><div class="item-label">Jackets</div></div></a></li>
         <li><a href="/view/women/jackets/parkas/" title="Women's Parkas"><div class="item"><div class="item-label">Parkas</div></div></a></li>
         <li><a href="/view/women/jackets/material-fleece/" title="Women's Performance Fleece"><div class="item"><div class="item-label">Performance Fleece</div></div></a></li>
         <li><a href="/view/women/pants/type-ski/" title="Women's Ski Pants"><div class="item"><div class="item-label">Ski Pants</div></div></a></li>
         <li><a href="/view/women/jackets/trench-coats/" title="Women's Trench Coats"><div class="item"><div class="item-label">Trenches &amp; Coats</div></div></a></li>
         <li><a href="/view/women/vests/" title="Women's Vests"><div class="item"><div class="item-label">Vests</div></div></a></li>
      </ul>
   </div>
   <div class="group">
      <a role="link" href="/view/kids/" title="Kids' Clothing">
         <h2 class="title">Kids</h2>
      </a>
      <ul>
         <li><a href="/view/boy/jackets/" title="Boys' Jackets"><div class="item"><div class="item-label">Boys</div></div></a></li>
         <li><a href="/view/girl/jackets/" title="Girls' Jackets"><div class="item"><div class="item-label">Girls</div></div></a></li>
      </ul>
   </div>
</div>
</div>`